import axios from 'axios';
import { ErrorDto } from 'services/dtos/errors-dto';
import { useErrorHandler } from 'tools/error-handler';
import {
    CreateSingleUsePassInput,
    CreateSingleUsePassResponse,
    SingleUsePasses,
} from 'services/single-use-passes/single-use-passes.service';

export const useAPISingleUsePasses = (): SingleUsePasses => {
    const errorHandler = useErrorHandler();

    const createSingleUsePass = async (
        accessToken: string,
        input: CreateSingleUsePassInput,
    ): Promise<CreateSingleUsePassResponse> => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_MOBILE_PASSCODES_BASE_URL + `/user/single-use-passes`,
                input,
                { headers: { Authorization: 'Bearer ' + accessToken } },
            );
            return { ...response.data, id: response.data.id.toLowerCase() } as CreateSingleUsePassResponse;
        } catch (err: unknown) {
            errorHandler(err);
            const error = err as ErrorDto;
            throw error.response.data.msg;
        }
    };

    return { createSingleUsePass };
};
